import {white} from 'material-ui/styles/colors';

    const styles = {
      paper: {
        minHeight: 200,
        padding: 10
      },
      noBorder:{
        border: 0,
        boxShadow:0,
        background: 'transparent',
        color: white,
        paddingTop: 20,
        paddingBottom: 20
      },
      mediaContainer:{
        margin: 'auto',
        width: '150px'
      }
  };
export default styles;


// WEBPACK FOOTER //
// ./src/components/dashboard/styles/LinkToBoxStyles.js